// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantComparison-moduleRentalPortalApplicantComparison__kT6Xa";
var _2 = "RentalPortalApplicantComparison-moduleheaderLabelCell__qyjKQ TableHeaderRowCell-moduleTableHeaderRowCell__zrJys";
export { _1 as "RentalPortalApplicantComparison", _2 as "headerLabelCell" }
